export default __webpack_public_path__ + "static/media/white-5.4a3e67a1.png";